"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebugLayer = void 0;
const FixRatioContainer_1 = require("../Common/FixRatioContainer");
const Constants_1 = require("../Core/Constants");
const inversify_1 = require("inversify");
const SymbolClasses_1 = require("../Utils/SymbolClasses");
const pixi_js_1 = require("pixi.js");
const GameConfig_1 = require("../Core/GameConfig");
let DebugLayer = class DebugLayer extends FixRatioContainer_1.FixRatioContainer {
    constructor(events, config) {
        super(Constants_1.LayerWidth, Constants_1.LayerHeight);
        this.visible = !!config.debug;
        this.alpha = 0.2;
        this.resize(...events.Resize.prevArgs);
        events.Resize.add((remove, w, h) => {
            if (!this.parent)
                return remove();
            this.resize(w, h);
        });
        const border = new pixi_js_1.Graphics();
        border.lineStyle(2, 0xff8800);
        border.moveTo(0, 0).lineTo(0, Constants_1.LayerHeight).lineTo(Constants_1.LayerWidth, Constants_1.LayerHeight).lineTo(Constants_1.LayerWidth, 0).lineTo(0, 0);
        this.addChild(border);
        const nearFarLines = new pixi_js_1.Graphics();
        nearFarLines.lineStyle(4, 0x0088ff);
        nearFarLines.moveTo(0, Constants_1.LaneBottomY).lineTo(Constants_1.LayerWidth, Constants_1.LaneBottomY);
        nearFarLines.lineStyle(2, 0x0088ff);
        nearFarLines.moveTo(0, Constants_1.FarLineY).lineTo(Constants_1.LayerWidth, Constants_1.FarLineY);
        this.addChild(nearFarLines);
        const centerLines = new pixi_js_1.Graphics();
        centerLines.lineStyle(2, 0x004422);
        Constants_1.LaneCenterXs.forEach(x => {
            centerLines.moveTo(Constants_1.CenterX, Constants_1.LaneInfY).lineTo(x, Constants_1.LaneBottomY);
        });
        this.addChild(centerLines);
        const borderLines = new pixi_js_1.Graphics();
        borderLines.lineStyle(2, 0x00aa44);
        const borderXs = Constants_1.LaneCenterXs.map(x => x - Constants_1.LaneWidth / 2);
        borderXs.push(borderXs[borderXs.length - 1] + Constants_1.LaneWidth);
        borderXs.forEach(x => {
            borderLines.moveTo(Constants_1.CenterX, Constants_1.LaneInfY).lineTo(x, Constants_1.LaneBottomY);
        });
        this.addChild(borderLines);
    }
};
DebugLayer = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [SymbolClasses_1.GlobalEvents, GameConfig_1.GameConfig])
], DebugLayer);
exports.DebugLayer = DebugLayer;
//# sourceMappingURL=DebugLayer.js.map